import { render, staticRenderFns } from "./ModelKeyShare.vue?vue&type=template&id=6f4ad4c1&scoped=true"
import script from "./ModelKeyShare.vue?vue&type=script&lang=js"
export * from "./ModelKeyShare.vue?vue&type=script&lang=js"
import style0 from "./ModelKeyShare.vue?vue&type=style&index=0&id=6f4ad4c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4ad4c1",
  null
  
)

export default component.exports